import { IParameterProperty } from '../../../../../../types/IParameter';
import Parameter from '../../Parameter';
import { TopContentResult } from '../../../components/ComboBox';

export interface IComboboxParameterProperty extends IParameterProperty {
  comboBoxUrl: {
    url: string;
  };
}

class Combobox extends Parameter {
  public comboBoxUrl: { url: string };
  public selected: any;

  constructor(parameter: IComboboxParameterProperty) {
    super(parameter);

    this.comboBoxUrl = parameter.comboBoxUrl;
    this.selected = parameter.selected;
  }

  public reset = () => {
    this.selected = null;
    this.value = this.originalValue;
  };

  public clear = () => {
    this.selected = null;
    this.value = undefined;
  };

  // used to put items from a contentResult to selected items
  public setSelected(item: TopContentResult | undefined) {
    this.selected = item;
    this.value = item?.id;
  }
}

export default Combobox;
